import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_STORAGE_SECRET || "SYMCARE_SUPER_SECRET";

/**
 * Encrypt + store
 */
export const setSecureItem = (key, value) => {
    const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(value),
        SECRET_KEY
    ).toString();

    localStorage.setItem(key, encrypted);
};

/**
 * Decrypt + read
 */
export const getSecureItem = (key) => {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return null;

    try {
        const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (err) {
        console.warn("Tampered localStorage detected:", key);
        return null;
    }
};

/**
 * Remove
 */
export const removeSecureItem = (key) => {
    localStorage.removeItem(key);
};
